import { Decodable } from "./_decodable";
import { ProposalBillingItem } from "./proposal-billing-item";

export interface ProposalReceiptSummary {
    totalReceipts: number;
    totalReceiptAmount: number;
    totalProposalAmount: number;
    remainingAmount: number;
    exceededAmount: number;
    paidItemsWithoutReceipts: ProposalBillingItem[];
}

export class ProposalReceipt extends Decodable {
    id?: number;
    accountId?: number;
    proposalId?: number;
    proposalBillingItemId?: number;
    clientId?: number;
    issuedByCustomerId?: number;
    receiptNumber?: number;
    issueDate?: Date;
    amount: number = 0;
    paymentReference?: string;
    paymentMethod?: string;
    paymentMethodName?: string;
    description?: string;
    showSignature: boolean = true;
    token?: string;
    companySnapshot?: any;
    clientSnapshot?: any;
    proposalSnapshot?: any;
    billingItemSnapshot?: any;
    billingItem?: ProposalBillingItem;
    createdAt?: Date;
    updatedAt?: Date;

    protected _map = {
        amount: (e) => Number(e),
        receiptNumber: (e) => Number(e),
        showSignature: (e) => !!e,
        issueDate: (e) => this.parseDate(e),
        billingItem: (e) => ProposalBillingItem.parse(e),
        createdAt: (e) => this.parseDate(e),
        updatedAt: (e) => this.parseDate(e),
    };
}
